import { render, staticRenderFns } from "./inserirPautaFarmaciaFarmacologia.vue?vue&type=template&id=5435bc86&"
import script from "./inserirPautaFarmaciaFarmacologia.vue?vue&type=script&lang=js&"
export * from "./inserirPautaFarmaciaFarmacologia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports